const lineHover = {
  wraps: document.querySelectorAll('.jsLineWrap') as NodeListOf<Element>,

  init() {
    this.hover();
  },

  hover() {
    this.wraps.forEach((wrap) => {
      const line = wrap.querySelector('.jsLine') as HTMLElement;
      const links = wrap.querySelectorAll(
        '.jsLineLink',
      ) as NodeListOf<HTMLElement>;

      links.forEach((item) => {
        item.addEventListener(
          'mouseover',
          () => {
            line.style.width = item.offsetWidth + 'px';
            line.style.left =
              item.getBoundingClientRect().left -
              wrap.getBoundingClientRect().left +
              'px';
          },
          { passive: true },
        );
      });
      wrap.addEventListener(
        'mouseleave',
        () => {
          line.style.width = '0';
        },
        { passive: true },
      );
    });
  },
};

export default lineHover;
